// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  msalConfig: {
    auth: {
      clientId: '4ad4af54-ae8d-4f46-8b23-ea9d9319504b',
      authority: 'https://login.microsoftonline.com/36da45f1-dd2c-4d1f-af13-5abe46b99921',
      redirectUri: 'https://sddr.deloitte.com/',
      postLogoutRedirectUri: '/'
    },
  },
  apiConfig: {
    scopes: ['user.read'],
    uri: 'https://graph.microsoft.com/v1.0/me',
  },
  scopes: ['https://dapi.ddr.deloitte.com/user_impersonation'],
  apiEndpoint: 'https://sapi.ddr.deloitte.com/api',
  worldPayEndpoint: 'https://sapi.ddr.deloitte.com/worldpay',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
